import angular from 'angular';
import {MaintenanceUsersListBridge} from './MaintenanceUsersListBridge';

angular
  .module('flowingly.runner.maintenance')
  .component('maintenanceUsersList', MaintenanceUsersListBridge);
